import { firstValueFrom, Observable } from 'rxjs';

export class AsyncCache<T> {
	private cache = new Map<string, CacheEntry<T>>();

	async getByKey(key: string) {
		const existing = this.cache.get(key);

		if (existing) {
			return existing.data;
		} else {
			return null;
		}
	}

	async get(key: string, factory: () => Observable<T>): Promise<T> {
		const existing = this.cache.get(key);

		if (existing) {
			// Wenn bereits geladen, direkt zurückgeben
			if (existing.data !== undefined) {
				return existing.data;
			}
			// Wenn gerade lädt, auf das Promise warten
			if (existing.loading) {
				return existing.loading;
			}
		}

		// Neuen Request starten
		const loadingPromise = firstValueFrom(factory());
		this.cache.set(key, { data: undefined as any, loading: loadingPromise });

		try {
			const result = await loadingPromise;
			this.cache.set(key, { data: result, loading: null });
			return result;
		} catch (error) {
			this.cache.delete(key); // Bei Fehler aus Cache entfernen
			throw error;
		}
	}

	delete(key: string): void {
		this.cache.delete(key);
	}

	clear(): void {
		this.cache.clear();
	}
}

interface CacheEntry<T> {
	data: T;
	loading: Promise<T> | null;
}
